export const ProjectPopup = ({children}) => {
  return (
    <div className={"project-popup"}>
      <div className={"project-popup-bg"}>
        {children}
      </div>
    </div>
  )
}